import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as terapiaPlanService from "../../services/terapiaPlanService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { setValue, setListFilial, setListEstadoVigencia, setListEstado } from '../../redux/therapyPlanSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly, idFilial, perfilCargado } = useMantenimiento("terapiaPlan");
    const filters = useSelector((state) => state.therapyPlanSearch.filters);
    const listFilial = useSelector((state) => state.therapyPlanSearch.listFilial);
    const listEstadoVigencia = useSelector((state) => state.therapyPlanSearch.listEstadoVigencia);
    const listEstado = useSelector((state) => state.therapyPlanSearch.listEstado);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async (filtros = filters) => {
        setCargando(true);

        await terapiaPlanService.getsTerapiaPlanResumenView(filtros)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchFilial = async () => {
        await filialService.getFilialesList()
            .then((data) => {
                // Si el usuario tiene filial asignada, su filtro solo ofrece esa.
                dispatch(setListFilial(filialService.soloFilialDelUsuario(data, idFilial)));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstadoVigencia = async () => {
        await catalogoService.getCatalogosByPadre(90)
            .then((data) => {
                dispatch(setListEstadoVigencia(data));
                dispatch(setValue({name: "idEstadoVigencia", value: 91}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstado = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstado(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await terapiaPlanService.annulTerapiaPlan(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await terapiaPlanService.activeTerapiaPlan(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchEstadoVigencia();
        fetchEstado();
    }, []);

    // El filtro de filial se arma cuando llega el perfil del usuario: si se
    // armara antes, se verian todas las sedes. Con una filial asignada el
    // filtro queda fijo en esa y el listado sale ya acotado.
    useEffect(() => {
        if (!perfilCargado) return;

        fetchFilial();

        if (idFilial > 0) {
            dispatch(setValue({ name: "idFilial", value: idFilial }));
            fetchResults({ ...filters, idFilial });
        }
        else {
            fetchResults();
        }
    }, [perfilCargado, idFilial]);

    const columns = [
        { field: 'idTerapiaPlan', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'codigoFilial', headerName: 'Filial', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 175, sortable: true, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/therapyplan/edit/'
                    + (cellValues.row.idTerapiaPlan == null ? 0 : cellValues.row.idTerapiaPlan)
                    + '/' + + cellValues.row.idTerapia }
                    style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 175, sortable: false, headerAlign: 'center' },
        { field: 'numero', headerName: 'Numero', width: 65, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fechaInicio', headerName: 'Inicio', width: 105, sortable: false, headerAlign: 'center', align: 'center'
            , valueFormatter: (value) => (value ? moment(value).format('DD/MM/YYYY') : "") },
        { field: 'periodicidad', headerName: 'Periodicidad', width: 110, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'horario', headerName: 'Horario', width: 250, sortable: false, headerAlign: 'center' },
        // { field: 'codigoTarifa', headerName: 'Tarifa', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'salon', headerName: 'Salon', width: 100, sortable: false, headerAlign: 'center' },
        // { field: 'fechaInicio', headerName: 'Inicio', width: 120, type: 'date'
        //     , valueFormatter: (value) => moment(value).format('DD/MM/YYYY')
        //     , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estadoVigencia', headerName: 'Vigente', width: 80, sortable: false, headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                // Sin plan no hay nada que anular ni activar: la terapia
                // aparece para crearle el primero.
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"}
                    disabled={isReadOnly || cellValues.row.idTerapiaPlan == null} onClick={() => {
                        setSelectId(cellValues.row.idTerapiaPlan);
                        setSelectState(cellValues.row.estado);
                        setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Planes de Terapia
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filial" shrink>Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        disabled={idFilial > 0}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idFilial", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idFilial',
                                            id: 'input-filial',
                                        }}
                                        size="small"
                                    >
                                        {idFilial <= 0 && <option key={0} value={0}>{"(Todos)"}</option>}
                                        {listFilial.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="member"
                                    label="Participante"
                                    value={filters.member}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "member", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="therapist"
                                    label="Terapeuta"
                                    value={filters.therapist}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "therapist", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estadovigencia" shrink>Vigencia</InputLabel>
                                    <Select
                                        native
                                        label="Vigencia"
                                        value={filters.idEstadoVigencia}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstadoVigencia", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstadoVigencia',
                                            id: 'input-estadovigencia',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstadoVigencia.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstado.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        // La terapia no se elige aqui: se busca con
                                        // la lupa desde la ventana de mantenimiento.
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/therapyplan/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Plan de Terapia"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el plan de terapia?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
